"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var HorDefault_1 = require("./HorDefault");
var MiniSidebar_1 = require("./MiniSidebar");
var DrawerLayout_1 = require("./DrawerLayout");
var Standard_1 = require("./Standard");
var BitBucket_1 = require("./BitBucket");
var HorLightNav_1 = require("./HorLightNav");
var HorDarkLayout_1 = require("./HorDarkLayout");
var AppEnums_1 = require("../../../shared/constants/AppEnums");
var DefaultLayout_1 = require("./DefaultLayout");
var UserHeader_1 = require("./UserHeader");
var UserHeaderMini_1 = require("./UserHeaderMini");
var MiniSidebarToggle_1 = require("./MiniSidebarToggle");
var Layouts = (_a = {},
    _a[AppEnums_1.NavStyle.STANDARD] = Standard_1.default,
    _a[AppEnums_1.NavStyle.DEFAULT] = DefaultLayout_1.default,
    _a[AppEnums_1.NavStyle.HEADER_USER] = UserHeader_1.default,
    _a[AppEnums_1.NavStyle.HEADER_USER_MINI] = UserHeaderMini_1.default,
    _a[AppEnums_1.NavStyle.MINI_SIDEBAR_TOGGLE] = MiniSidebarToggle_1.default,
    _a[AppEnums_1.NavStyle.MINI] = MiniSidebar_1.default,
    _a[AppEnums_1.NavStyle.DRAWER] = DrawerLayout_1.default,
    _a[AppEnums_1.NavStyle.BIT_BUCKET] = BitBucket_1.default,
    _a[AppEnums_1.NavStyle.H_DEFAULT] = HorDefault_1.default,
    _a[AppEnums_1.NavStyle.HOR_LIGHT_NAV] = HorLightNav_1.default,
    _a[AppEnums_1.NavStyle.HOR_DARK_LAYOUT] = HorDarkLayout_1.default,
    _a);
exports.default = Layouts;
//# sourceMappingURL=Layouts.js.map